import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DxPopupComponent } from 'devextreme-angular';
import { LanguageService } from "../../services/language.service";

var self : PopupComponent;
@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.css"]
})
export class PopupComponent {

  @ViewChild(DxPopupComponent, { static: false }) popup: DxPopupComponent;

  @Input() popupVisible = false;
  @Input() title: string;
  @Input() fullScreen = false;
  @Input() width: number;
  @Input() height: number;
  @Input() canRefresh = false;
  @Input() canSave = false;
  @Input() canDelete = false;
  @Input() canComplete = false;
  @Input() saveEnabled = true;
  @Input() isBusy = false;

  @Output() saveClicked = new EventEmitter<void>();
  @Output() refreshClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<void>();
  @Output() completeClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();
  @Output() showing = new EventEmitter<void>();
  @Output() shown = new EventEmitter<void>();

  constructor(public languageService: LanguageService) {
    self = this;
  }

  ngAfterViewInit() {
    this.popup.instance.registerKeyHandler('escape', function ( e ) {
      self.closeClicked.emit();
    });
  }

  
}
